<template>
  <page-wrapper :title="title">
    <loading-overlay :active="isLoading" />
    <div class="header">
      <sc-button :route="createRoute" class="create-button" variant="primary"
        >เพิ่มประกาศ</sc-button
      >
    </div>
    <div v-for="item in list" :key="item.id" class="notice-row">
      <router-link :to="item.route" class="title">{{ item.title }}</router-link>
      <p v-if="item.subtitle" class="subtitle">{{ item.subtitle }}</p>
      <div v-if="item.note" class="note text-danger">{{ item.note }}</div>
      <div class="meta">
        <div class="subtitle">
          <span class="label">ระยะเวลาติดประกาศ</span>
          <div class="value">{{ item.publishDate }}</div>
        </div>
        <div class="subtitle">
          <span class="label">วันในปฎิทิน</span>
          <div class="value">{{ item.calendarDate }}</div>
        </div>
        <div class="subtitle">
          <span class="label">ประกาศโดย</span>
          <div class="value">{{ item.createdBy }}</div>
        </div>
        <div class="subtitle">
          <div class="label">สร้างเมื่อ</div>
          <div class="value">{{ item.createdAt }}</div>
        </div>
      </div>
    </div>
    <div class="wrapper text-end padding-adjust">
      <el-pagination
        :total="total"
        :page-size="10"
        :current-page="queryParams.page"
        background
        layout="prev, pager, next"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>
  </page-wrapper>
</template>

<script>
import { baanRueJaiClient } from "@/dependencies"
import LoadingOverlay from "@/lib/components/LoadingOverlay"
import PageWrapper from "@/lib/components/PageWrapper"
import ScButton from "@/lib/components/ScButton"
import { toLocaleTH } from "@/lib/dateTime"
import { Pagination } from "element-ui"
import { DateTime } from "luxon"

export default {
  components: {
    PageWrapper,
    ScButton,
    LoadingOverlay,
    "el-pagination": Pagination
  },
  data() {
    const title = "รายการประกาศ"
    const createRoute = { name: "NoticeCreatePage" }
    const total = 0
    const list = []

    return {
      title,
      list,
      total,
      createRoute,
      isLoading: false
    };
  },
  computed: {
    queryParams() {
      return {
        page: parseInt(this.$route.query.page, 10) || 1,
      }
    },
  },
  watch: {
    "$route.query": async function routeQueryWatcher() {
      await this.setupData()
    },
  },
  created() {
    this.setup()
  },
  methods: {
    setup() {
      this.setupData()
    },
    setupData() {
      this.setupList()
    },
    handleCurrentChange(page) {
      const route = {
        query: { ...this.$route.query, page },
      }

      this.$router.replace(route)
    },
    async setupList() {
      this.isLoading = true;
      const { notices, count } = await this.fetchList(this.queryParams);

      this.list = notices.map((item) => {
        const publishDate = `${this.formatDate(item.published_start_at)} - ${this.formatDate(item.published_end_at)}`
        let calendarDate
        if (item.start_at !== null && item.end_at !== null) {
          calendarDate = `${this.formatDate(item.start_at)} - ${this.formatDate(item.end_at)}`
        } else {
          calendarDate = "not set"
        }
        const createdBy = `${item.admin.first_name} ${item.admin.last_name}`
        const route = { name: "NoticeDetailPage", params: { id: item.id } }
        const subtitle = this.getListItemSubtitle(item)
        const createdAt = this.formatDate(item.created_at)
        this.total = count

        return {
          id: item.id,
          title: item.title,
          subtitle,
          publishDate,
          calendarDate,
          createdBy,
          route,
          note: item.delete_at ? "ถูกลบ" : null,
          createdAt
        };
      });
      this.isLoading = false;
    },
    async fetchList(queryParams) {
      const response =
        await baanRueJaiClient.admin.communications.notices.list(queryParams)

      return response.data.result
    },
    getListItemSubtitle(item) {
      if (item.subtitle) {
        return item.subtitle
      }

      if (item.start_at && item.end_at) {
        return `${this.formatDate(item.start_at)} - ${this.formatDate(item.end_at)}`
      }

      return undefined
    },
    formatDate(date) {
      const format = "dd MMMM yyyy"

      return toLocaleTH(DateTime.fromISO(date)).toFormat(format)
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.header {
  padding: 30px;
  border-bottom: $border;
}

.notice-row {
  padding: 15px 30px;

  > .title {
    font-size: 1.2rem;
    margin-bottom: 5px;
  }

  border-bottom: $border;
}

.meta {
  display: grid;
  grid-template-columns: 300px 300px 200px 200px;
  grid-gap: 20px;
}

.label {
  color: #777;
  font-size: 0.9rem;
}

.value {
  font-size: 1rem;
}

.note {
  font-size: 0.8rem;
}

.padding-adjust {
  padding: 10px 0;
}
</style>
